import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import CalendarEventController from "./CalendarEventController";

const calendarDayEventTemplate = require("./CalendarDayEvent.tpl.html");

const CalendarDayEventComponent = {
    name: "tbCalendarDayEvent",
    config: {
        template: calendarDayEventTemplate,
        bindings: {
            eventData: "=tbEventData",
            editorNavigateFn: "&tbEditorNavigateFn",
            eventSelected: "&tbEventSelected",
            eventTextClass: "@tbEventTextClass"
        },
        controller: CalendarEventController,
        controllerAs: CalendarEventController.controllerAs
    }
};

CalendarDayEventComponent.dependencies = DependencyListBuilder([
    CalendarEventController.dependencies
]);

export default CalendarDayEventComponent;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarDayEvent.js
// module id = cEDF
// module chunks = 1